import React from 'react';
import styles from 'components/show_drawing/redraw_form/_style.module.scss';
import OptionsCommon from 'components/show_drawing/redraw_form/options/OptionsCommon.jsx';

// One row of the technical-properties popup, styled to match the tag popup's
// rows (SelectFlap / the boolean rows): a full-width row with the option name
// on the left and its control on the right — not the boxed input-group the
// generic OptionSelect renders. Reuses OptionsCommon for the value /
// visible-choice logic.
//
// redrawOnChange is off: picking a value stages it in the form but does not
// redraw the dieline. The popup's "Confirm technical properties" button is
// what commits the staged choices with a single redraw (see
// TechnicalPropertyOptions).
//
// Technical-property options are select-type; a non-select one still renders
// its value, but the row is built for the dropdown case.
const TechnicalPropertyOptionRow = ({ id, drawing, option, unit, optionsUserChanged, addToOptionsUserChanged, setRedrawRequested, isLast }) => {
  const formattedValue = (value) => value;
  const redrawOnChange = false;
  const [isVisible, value, , , onChange, showAbcHelperLine, , , , visibleSelectChoices] = OptionsCommon({
    formattedValue,
    id,
    drawing,
    option,
    unit,
    optionsUserChanged,
    addToOptionsUserChanged,
    setRedrawRequested,
    redrawOnChange,
    labelGroup: 'technical_properties'
  });

  if (!isVisible) { return <input type="hidden" name={option.name} value={value} /> }

  const choices = visibleSelectChoices || [];

  return (
    <div className={`${styles.tp_option_row} ${isLast ? styles.last_tag : ''}`}>
      <span className={styles.tp_option_name}> {option.presented_name} </span>

      <span className={styles.tp_option_control}>
        <select
          name={option.name}
          value={value}
          onChange={onChange}
          onFocus={showAbcHelperLine}
          className="drawing-option-input form-control"
        >
          {choices.map((choice) => <option key={choice.value} value={choice.value}> {choice.description} </option>)}
        </select>
      </span>
    </div>
  );
};

export default TechnicalPropertyOptionRow;
